import { sort } from "./Utilities/DataUtilities";

export const ApprovalGroups = {
    Institution: 1,
    InstitutionAdmin: 2,
    ISBEAdmin: 3,
    Support: 4
};

export const ValidationStatus = {
    Unresolved: 1,
    Acknowledged: 2,
    Resolved: 3,
    NoIssues: 4
};


/***
 * FROM BRADEN TO NICK (November 2021)
 * Nick,
I am copying the PBI syntax below.  Essentially it�s an elaborate case statement but not sure if you�ll be working SQL or other language,
    so feel free to ask if you have specific questions.  Beneath the status logic, I am including the PBI measure/aggregate logic.  Again, probably will
    manifest differently in code, but at least you can see what values the status logic will need for consideration.  Lastly, the PBI dataset comes from
    EPP.Accountability.vwPBIAccountabilityProgramDomainSummary.  Logic for some of the values is buried in the view SQL, otherwise you could probably
    just source directly from this view an follow the PBI logic to get most of what you need.
    
Reauthorization Status = SWITCH(
    TRUE(),          --ignore this section, PBI-specific syntax
    'Program Domain Summary'[New Program Indicator] > 0, "Reauthorized",
    'Program Domain Summary'[Domain Count] = 0,"Program Under Review",
    'Program Domain Summary'[Domain Count] < 3,"Reauthorized With Conditions",
    'Program Domain Summary'[Domain Percentage] >= 0 && 'Program Domain Summary'[Domain Percentage] <= .25,"On Probation",
    'Program Domain Summary'[Domain Percentage] > .25 && 'Program Domain Summary'[Domain Percentage] <= .5,"Reauthorized With Conditions",
    'Program Domain Summary'[Domain Percentage] > .5 && 'Program Domain Summary'[Domain Percentage] <= .75,"Reauthorized",
    'Program Domain Summary'[No Data Indicator] = 11,"Reauthorized",
    'Program Domain Summary'[Domain Count] = 4 && 'Program Domain Summary'[Domain Percentage] > .75,"Reauthorized With Distinction",
    "Reauthorized"
)
�         New Program Indicator
o   You�ll need to look at the �Ineligibility Rule� column for the particular indicator.  If it indicates �Program less than 4 years old�, then it should be considered a new program
�         Domain Count
o   This is a simple count of how many applicable domains are being considered in the calculation
�         Domain Percentage
o   Count of points earned / count of total points possible
�         No Data Indicator
o   Similar to New Program Indicator.  If all 11 indicators in the set indicates �No data available� the indicator is set.
 * 
 * */
export const ReauthorizationCalculation = {
    distinction: {
        label: "Reauthorized With Distinction",
        get description() {
            return GetReauthorizedDescription(this);
        },
        get friendlierDescription() {
            return GetReauthorizedFriendlierDescription(this);
        },
        bgColor: "exemplary",
        textColor: "white",
        range: {
            min: 0.75,
            max: 1
        }
    },
    regular: {
        label: "Reauthorized",
        get description() {
            return GetReauthorizedDescription(this);
        },
        get friendlierDescription() {
            return GetReauthorizedFriendlierDescription(this);
        },
        bgColor: "commendable",
        textColor: "black",
        range: {
            min: 0.5,
            max: 0.75
        }
    },
    conditions: {
        label: "Reauthorized With Conditions",
        get description() {
            return GetReauthorizedDescription(this);
        },
        get friendlierDescription() {
            return GetReauthorizedFriendlierDescription(this);
        },
        bgColor: "developing",
        textColor: "black",
        range: {
            min: 0.25,
            max: 0.5
        }
    },
    noScore: {
        label: "No Score",
        get description() {
            return "Not enough data";
        },
        bgColor: "no-score",
        textColor: "white",
        range: {
            min: 0,
            max: 0
        },
        tooltip: `A teacher preparation program will receive "No Score" if the program:
        <ul>
            <li class="my-1">Limited Data Available - Has less than 10 candidates enrolled or has less than 10 completers serving students in Illinois' public education system.</li>
            <li class="mb-1">Recently Approved - Has been recently approved (with in the last 3 years)  by the Illinois State Board of Education and does not have enough years of data.</li>
            <li>Discontinued - Has been discontinued and is no longer enrolling candidates</li>
            <li>Coming Soon - ISBE partnered with the Illinois Department of Employment Security to gather data on early childhood program completers placed in Community-Based Organizations. These data will be available in Spring 2021.</li>
        </ul>`
    },
    review: {
        label: "Limited Data Available",
        get description() {
            return "Program under review";
        },
        bgColor: "no-score",
        textColor: "white",
        range: {
            min: 0,
            max: 0
        },
        tooltip: `A teacher preparation program will receive "No Score" if the program:
        <ul>
            <li class="my-1">Limited Data Available - Has less than 10 candidates enrolled or has less than 10 completers serving students in Illinois' public education system.</li>
            <li class="mb-1">Recently Approved - Has been recently approved (with in the last 3 years)  by the Illinois State Board of Education and does not have enough years of data.</li>
            <li>Discontinued - Has been discontinued and is no longer enrolling candidates</li>
            <li>Coming Soon - ISBE partnered with the Illinois Department of Employment Security to gather data on early childhood program completers placed in Community-Based Organizations. These data will be available in Spring 2021.</li>
        </ul>`
    },
    probation: {
        label: "On Probation",
        get description() {
            return "Program on probation";
        },
        bgColor: "needs-improvement",
        textColor: "white",
        range: {
            min: 0,
            max: 0
        },
        tooltip: `A teacher preparation program will receive "No Score" if the program:
        <ul>
            <li class="my-1">Limited Data Available - Has less than 10 candidates enrolled or has less than 10 completers serving students in Illinois' public education system.</li>
            <li class="mb-1">Recently Approved - Has been recently approved (with in the last 3 years)  by the Illinois State Board of Education and does not have enough years of data.</li>
            <li>Discontinued - Has been discontinued and is no longer enrolling candidates</li>
            <li>Coming Soon - ISBE partnered with the Illinois Department of Employment Security to gather data on early childhood program completers placed in Community-Based Organizations. These data will be available in Spring 2021.</li>
        </ul>`
    },
    discontinued: {
        label: "Discontinued",
        get description() {
            return "Program discontinued";
        },
        bgColor: "discontinued",
        textColor: "white",
        range: {
            min: 0,
            max: 0
        }
    },
    getReauthorization(facts, domain) {
        /**
         * 
         * fact object model: {
                    "FactProgramId": 6305,
                    "DomainIndicatorId": 1,
                    "EntityId": 129,
                    "ProgramId": 7,
                    "IneligibilityReasonId": null,
                    "IndicatorPointsEarned": 0,
                    "MeetsCount": 187,
                    "PossibleCount": 286
                },
         * 
         * */

        //'Program Domain Summary'[New Program Indicator] > 0, "Reauthorized",
        const isNewProgram = facts.some(f => f.IneligibilityReasonId == 4);
        if (isNewProgram) return this["regular"];

        const scoredFacts = this.getScoredFacts(facts);
        const uniqueScoredDomains = this.getUniqueScoredDomains(scoredFacts, domain);

        //'Program Domain Summary'[Domain Count] = 0, "Program Under Review",
        if (uniqueScoredDomains.length == 0) return this["review"];
        //'Program Domain Summary'[Domain Count] < 3, "Reauthorized With Conditions",
        if (uniqueScoredDomains.length < 3) return this["conditions"];

        let totalEarned = 0;
        let totalPossible = 0;
        scoredFacts.forEach(x => {
            totalEarned += x.IndicatorPointsEarned;
            let pointsPossible = domain.Indicators.find(y => y.DomainIndicatorId === x.DomainIndicatorId);
            totalPossible += pointsPossible ? pointsPossible.PointsPossible : 0;
        });
        const percentile = totalEarned / totalPossible;

        //'Program Domain Summary'[Domain Percentage] >= 0 && 'Program Domain Summary'[Domain Percentage] <= .25, "On Probation",
        if (percentile <= 0.25) return this["probation"];
        //'Program Domain Summary'[Domain Percentage] > .25 && 'Program Domain Summary'[Domain Percentage] <= .5, "Reauthorized With Conditions",
        if (percentile <= 0.5) return this["conditions"];
        //'Program Domain Summary'[Domain Percentage] > .5 && 'Program Domain Summary'[Domain Percentage] <= .75, "Reauthorized",
        if (percentile <= 0.75) return this["regular"];

        //'Program Domain Summary'[No Data Indicator] = 11, "Reauthorized",
        const programHasNoData = facts.filter(f => f.IneligibilityReasonId == 6).length == 11;
        if (programHasNoData) return this["regular"];

        //'Program Domain Summary'[Domain Count] = 4 && 'Program Domain Summary'[Domain Percentage] > .75, "Reauthorized With Distinction",
        if (uniqueScoredDomains.length == 4 && percentile > 0.75) return this["distinction"];

        //"Reauthorized"
        return this["regular"];
    },
    getReauthorizationForReport(summaries, percentile, domainCount) {
        //'Program Domain Summary'[New Program Indicator] > 0, "Reauthorized",
        const isNewProgram = summaries.some(f => f.IneligibilityReasonId == 4);
        if (isNewProgram) return this["regular"];

        //'Program Domain Summary'[Domain Count] = 0, "Program Under Review",
        if (domainCount == 0) return this["review"];
        //'Program Domain Summary'[Domain Count] < 3, "Reauthorized With Conditions",
        if (domainCount < 3) return this["conditions"];

        //'Program Domain Summary'[Domain Percentage] >= 0 && 'Program Domain Summary'[Domain Percentage] <= .25, "On Probation",
        if (percentile <= 0.25) return this["probation"];
        //'Program Domain Summary'[Domain Percentage] > .25 && 'Program Domain Summary'[Domain Percentage] <= .5, "Reauthorized With Conditions",
        if (percentile <= 0.5) return this["conditions"];
        //'Program Domain Summary'[Domain Percentage] > .5 && 'Program Domain Summary'[Domain Percentage] <= .75, "Reauthorized",
        if (percentile <= 0.75) return this["regular"];

        //'Program Domain Summary'[No Data Indicator] = 11, "Reauthorized",
        const programHasNoData = summaries.filter(f => f.IneligibilityReasonId == 6).length == 11;
        if (programHasNoData) return this["regular"];

        //'Program Domain Summary'[Domain Count] = 4 && 'Program Domain Summary'[Domain Percentage] > .75, "Reauthorized With Distinction",
        if (domainCount == 4 && percentile > 0.75) return this["distinction"];

        //"Reauthorized"
        return this["regular"];
    },
    getScoredFacts(facts) {
        return facts.filter(x => !x.IneligibilityReasonId && x.IndicatorPointsEarned !== null);
    },
    getUniqueScoredDomains(scoredFacts, domain) {
        var scoredDomains = scoredFacts.map(sf => domain.Indicators.find(i => i.DomainIndicatorId === sf.DomainIndicatorId).DomainId);
        return [...new Set(scoredDomains)];
    }
    //getIneligibleFacts(facts) {
    //    return facts.filter(x => x.IneligibilityReasonId);
    //}
};

function GetReauthorizedDescription(domain) {
    let floor = (domain.range.min * 100);
    let ceiling = (domain.range.max * 100);
    return `${floor} ${ceiling < 100 ? "<" : "-"} ${ceiling}% of points`;
}

function GetReauthorizedFriendlierDescription(domain) {
    let floor = (domain.range.min * 100);
    let ceiling = (domain.range.max * 100);
    return `${floor}% to ${ceiling < 100 ? (ceiling - 1) + 0.99 : 100}% of points`;
}

export const DomainDesignation = {
    exemplary: {
        label: "Exemplary",
        get description() {
            return GetDomainDesignationDescription(this);
        },
        get friendlierDescription() {
            return GetDomainDesignationFriendlierDescription(this);
        },
        bgColor: "exemplary",
        textColor: "white",
        range: {
            min: 0.75,
            max: 1
        }
    },
    commendable: {
        label: "Commendable",
        get description() {
            return GetDomainDesignationDescription(this);
        },
        get friendlierDescription() {
            return GetDomainDesignationFriendlierDescription(this);
        },
        bgColor: "commendable",
        textColor: "white",
        range: {
            min: 0.5,
            max: 0.75
        }
    },
    developing: {
        label: "Developing",
        get description() {
            return GetDomainDesignationDescription(this);
        },
        get friendlierDescription() {
            return GetDomainDesignationFriendlierDescription(this);
        },
        bgColor: "developing",
        textColor: "white",
        range: {
            min: 0.25,
            max: 0.5
        }
    },
    needsImprovement: {
        label: "Needs Improvement",
        get description() {
            return GetDomainDesignationDescription(this);
        },
        get friendlierDescription() {
            return GetDomainDesignationFriendlierDescription(this);
        },
        bgColor: "needs-improvement",
        textColor: "white",
        range: {
            min: 0,
            max: 0.25
        }
    },
    noScore: {
        label: "No Score",
        get description() {
            return "Not enough data";
        },
        bgColor: "no-score",
        textColor: "white",
        range: {
            min: 0,
            max: 0
        },
        tooltip: `A teacher preparation program will receive "No Score" if the program:
        <ul>
            <li class="my-1">Limited Data Available - Has less than 10 candidates enrolled or has less than 10 completers serving students in Illinois' public education system.</li>
            <li class="mb-1">Recently Approved - Has been recently approved (with in the last 3 years)  by the Illinois State Board of Education and does not have enough years of data.</li>
            <li>Discontinued - Has been discontinued and is no longer enrolling candidates</li>
        </ul>`
    },
    getDesignation(facts, domain) {
        let totalEarned = 0;
        let totalPossible = 0;

        let scoredFacts = this.getScoredFacts(facts);

        scoredFacts.forEach(x => {
            totalEarned += x.IndicatorPointsEarned;
            let pointsPossible = domain.Indicators.find(y => y.DomainIndicatorId === x.DomainIndicatorId);
            totalPossible += pointsPossible ? pointsPossible.PointsPossible : 0;
        });

        let percentile = totalEarned / totalPossible;

        for (let key in this) {
            if (typeof this[key] === "object" &&
                this[key].range.min <= percentile &&
                this[key].range.max >= percentile) {
                return this[key];
            }
        }

        let ineligible = this.getIneligibleFacts(facts);
        let reasons = [];

        for (let i = 0; i < ineligible.length; i++) {
            let index = reasons.findIndex(x => x.ineligibilityReasonId === ineligible[i].IneligibilityReasonId);

            if (index === -1) {
                reasons.push({ ineligibilityReasonId: ineligible[i].IneligibilityReasonId, count: 1 });
            }
            else reasons[index].count += 1;
        }

        reasons = sort(reasons, { key: "count", direction: "desc" });

        return { ...this.noScore, ineligibilityReasonId: reasons.length > 0 ? reasons[0].ineligibilityReasonId : undefined };
    },
    getScoredFacts(facts) {
        return facts.filter(x => !x.IneligibilityReasonId && x.IndicatorPointsEarned !== null);
    },
    getIneligibleFacts(facts) {
        return facts.filter(x => x.IneligibilityReasonId);
    }
};

export const DataSnapshotPages = {
    filtered: {
        RaceEthnicity: "ReportSection",
        Gender: "ReportSection7571a4af512535a168ce",
        Demographic: "ReportSection3918b02c875de0059505",
        TrendingEnrollment: "ReportSection5d3c238feb8c2acb4a59"
    },
    stateWide: {
        RaceEthnicity: "ReportSection79a125d0a2c575124583",
        Gender: "ReportSectionb805faf1ab5275bde032",
        Demographic: "ReportSection762a380989e790888a5b",
        TrendingEnrollment: "ReportSectiona6f8bc49d33e9a439013"
    }
};

export const ExternalResources = {
    IEPP: {
        ReauthorizationGuide: "https://www.isbe.net/Documents/IEPP-Reauthorization-Guide.pdf",
        TechnicalGuide: "https://www.isbe.net/Documents/IEPP-Tech-Guide.pdf"
    }
};

function GetDomainDesignationDescription(domain) {
    let floor = (domain.range.min * 100);
    let ceiling = (domain.range.max * 100);
    return `${floor} ${ceiling < 100 ? "<" : "-"} ${ceiling}% of points`;
}

function GetDomainDesignationFriendlierDescription(domain) {
    let floor = (domain.range.min * 100);
    let ceiling = (domain.range.max * 100);
    return `${floor}% to ${ceiling < 100 ? (ceiling - 1) + 0.99 : 100}% of points`;
}